module.exports = __webpack_public_path__ + "img/icon-no-project.8cd7ec25.svg";